import { LanguageSwitch } from "@/components/ui/language-switch";

/** Language switch for auth-ui `footerSlot` (layout wrapper is in auth-ui). */
export function AuthFormFooter() {
  return <LanguageSwitch />;
}
